//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 
 const customFieldsColumns = [
  {
    name: 'name',
    required: true,
    label: 'Navn',
    align: 'left',
    field: row => row.name,
 
    sortable: true
  },
  {
    name: 'modelIDName',
    required: true,
    label: 'Uni model',
    align: 'left',
    field: row => row.modelIDName,

    sortable: true
  },
  {
    name: 'Opprettet',
    required: true,
    label: 'Opprettet i UNI',
    align: 'left',
    field: row => row.exist,

    sortable: true
  }
]



 import { mapActions } from "vuex";
  export default {
    mixins: ["wrapCsvValue"],
    data() {
      return {
        tab: "customFields",
        customFieldsColumns,
        customFieldsRows:[],
        pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "modelID",
        descending: false,
      },
      }
    },
  
    computed: {

    },
  
  
  
    methods: { 
        ...mapActions("main", ["getGetCustomFields", "addAndActivateRequiredFields"]),


        async createCustomFields(){
            await this.addAndActivateRequiredFields()
            this.customFieldsRows = await this.getGetCustomFields();

        }

    },
  
    async mounted() {
        this.customFieldsRows = await this.getGetCustomFields();
    },
  };
  